export const API_URL = 'https://api.rawg.io/api';
export const IMAGE_URL = 'https://media.rawg.io/media/';
export const SMALL_IMAGE_URL = 'https://media.rawg.io/media/resize/200/-/';
export const MEDIUM_IMAGE_URL = 'https://media.rawg.io/media/resize/640/-/';
export const LARGE_IMAGE_URL = 'https://media.rawg.io/media/resize/1280/-/';
export const LIGHTWEIGHT_IMAGE_URL = {
  VIDEO: 'https://media.rawg.io/media/crop/600/400/',
  NO_VIDEO: 'https://media.rawg.io/media/resize/640/-/'
};

export const INDEX_PATH = '/';
export const GAMES_PATH = '/games';
export const GAME_PATH = '/games/:slug';
export const USER_PATH = '/@:username';

export const PUBLIC_API_KEY = '88875ce36a0e44c7836738cb513a6b43';
